import React from "react";
import AboutUs from "../components/AboutUs";
import Contact from "../components/Contact";
import Navbars from "./Navbar";
import Games from "../components/Games";
import Play from "../components/Play";
import Services from "../components/Services";
import Partners from "../components/Partners";
import DocumentNav from "../components/DocumentNav";
import Jobs from "../components/Jobs";
import ScrollToAnchor from "../components/ScrollToAnchor";

const Layout = ({ children, isDark }: any) => {
  return (
    <React.Fragment>
      <Navbars isDark={isDark} />
      <ScrollToAnchor />
      {children}
      <Games />
      <Play />
      <AboutUs />
      <Services />
      <Jobs />
      <Partners />
      <Contact />
      <DocumentNav />
    </React.Fragment>
  );
};

export default Layout;
